import { API_BASE, messageFromErrorBody } from './authApi';
import { authHeaders } from './authStorage';

const jsonHeaders = () => ({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  ...authHeaders(),
});

function mapBoardFromApi(d) {
  return {
    id: d.id,
    companyId: d.companyId,
    companyName: d.companyName ?? '',
    name: d.name ?? '',
    purpose: d.purpose ?? '',
    type: d.type ?? 'executive',
    startDate: d.startDateUtc ? String(d.startDateUtc).slice(0, 10) : '',
    endDate: d.endDateUtc ? String(d.endDateUtc).slice(0, 10) : '',
    logoDataUrl: d.logoDataUrl ?? '',
    isActive: d.isActive !== false,
    membersCount: d.membersCount ?? 0,
  };
}

export async function fetchBoards(companyId) {
  const q = companyId ? `?companyId=${encodeURIComponent(companyId)}` : '';
  const res = await fetch(`${API_BASE}/api/boards${q}`, { headers: { Accept: 'application/json', ...authHeaders() } });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تحميل المجالس'));
  return (Array.isArray(data) ? data : []).map(mapBoardFromApi);
}

export async function createBoard(payload) {
  const res = await fetch(`${API_BASE}/api/boards`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إنشاء المجلس'));
  return mapBoardFromApi(data);
}

export async function fetchBoardById(id) {
  const res = await fetch(`${API_BASE}/api/boards/${id}`, {
    headers: { Accept: 'application/json', ...authHeaders() },
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'المجلس غير موجود'));
  return mapBoardFromApi(data);
}

export async function updateBoard(id, payload) {
  const res = await fetch(`${API_BASE}/api/boards/${id}`, {
    method: 'PUT',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر تعديل المجلس'));
  return mapBoardFromApi(data);
}

/** Create a board together with all its members in one atomic request. */
export async function createBoardWithMembers(payload) {
  const res = await fetch(`${API_BASE}/api/boards/with-members`, {
    method: 'POST',
    headers: jsonHeaders(),
    body: JSON.stringify(payload),
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(messageFromErrorBody(data, 'تعذر إنشاء المجلس'));
  return mapBoardFromApi(data);
}
